import React from 'react';

const Camera = (props) => {
  const { 
    width, 
    setUpBackgroundWidth,
    cameraStream,
  } = props;
  const cameraRef = React.useRef(null);
  const cameraContainerRef = React.useRef(null);

  React.useEffect( () => {
    if(cameraStream){
      cameraRef.current.srcObject = cameraStream
      cameraRef.current.play();
    }
  },[cameraStream])

  React.useEffect(() => {
    let panoramicElement = cameraContainerRef.current;
    if (panoramicElement) {
      setUpBackgroundWidth(panoramicElement.clientWidth);
    }
  }, [width]);

  return (
    <div className="video-container" ref={cameraContainerRef}>
      <video playsInline={true} ref={cameraRef}>Stream not available ...</video>
    </div>
  )
}

export default Camera;
